import { Experiment } from '@cian/experiments/ab';
import { MobileSlidingContainer } from '@cian/frontend-mobile-sliding-container';
import { Responsive } from '@cian/ui-kit';
import * as React from 'react';

import { PERS_MOBILE_RECS_IN_FAVORITES_V2_EXPERIMENT } from '../../constants/experiments';
import { BottomNavigationContainer } from '../../containers/BottomNavigationContainer';
import { ChatContainer } from '../../containers/ChatContainer';
import { DealTypeFilterContainer } from '../../containers/DealTypeFilterContainer';
import { EntityTypeToggleContainer } from '../../containers/EntityTypeToggleContainer';
import { ErrorContainer } from '../../containers/ErrorContainer';
import { RecommendationsContainer } from '../../containers/RecommendationsContainer';
import { ResultsMobileContainer } from '../../containers/ResultsMobileContainer';
import { ShowMoreBtnContainer } from '../../containers/ShowMoreBtnContainer';

export const MobilePage = () => {
  return (
    <>
      <DealTypeFilterContainer />
      <EntityTypeToggleContainer />

      <Experiment name={PERS_MOBILE_RECS_IN_FAVORITES_V2_EXPERIMENT} group="A" default>
        <ResultsMobileContainer />
        <ShowMoreBtnContainer />
      </Experiment>

      <Experiment name={PERS_MOBILE_RECS_IN_FAVORITES_V2_EXPERIMENT} group="B">
        <ResultsMobileContainer isExperimentEnabled />
        <ShowMoreBtnContainer isExperimentEnabled />
        <RecommendationsContainer isV2Experiment />
      </Experiment>

      <ChatContainer />
      <ErrorContainer />
      <Responsive tablet phone>
        <MobileSlidingContainer>
          <BottomNavigationContainer />
        </MobileSlidingContainer>
      </Responsive>
    </>
  );
};
